
import { useState } from "react";import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import adminMenu from "../menus/adminMenu.jsx";
import userMenu from "../menus/userMenu.jsx";
import logo from "../assets/logo.png";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const roles = useSelector((state) => state.user.roles || []);

  // 🔑 Determine effective role (priority: admin > user > subscriber)
  const effectiveRole = useMemo(() => {
    if (roles.includes("admin")) return "admin";
    if (roles.includes("user")) return "user";
    if (roles.includes("subscriber")) return "subscriber";
    return "guest";
  }, [roles]);

  // 🔑 Pick menu based on role
  const menuItems = useMemo(() => {
    switch (effectiveRole) {
      case "admin":
        return adminMenu;
      case "user":
        return userMenu;
      case "subscriber":
        return userMenu;
      default:
        return [];
    }
  }, [effectiveRole]);

  return (
    <aside className="w-64 bg-slate-900 text-white flex flex-col">
      {/* Logo */}
      <div className="h-16 flex items-center px-6 bg-[#FF8C42]/90 border-b border-white/20 shadow-md">
        <img src={logo} alt="SmartZman Logo" className="h-8 w-auto mr-3" />
        <span className="text-xl font-bold text-white">SmartZman</span>
      </div>

      {/* Menu */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {menuItems.map((item, idx) => (
          <NavLink
            key={idx}
            to={item.path}
            end={item.exact === true}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2 rounded-md transition-all duration-200 ${
                isActive
                  ? "bg-amber-500 text-black font-medium shadow-md"
                  : "text-slate-300 hover:bg-slate-800 hover:text-white"
              }`
            }
          >
            <span className="text-lg">{item.icon}</span>
            <span>{item.title}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;